import {cUtil}  from './../../../functions/util';

export class cProductItemSecondaryPackaging {
  
  fieldset_secondaryPackaging = document.createElement('fieldset');
  label_secondaryPackaging    = document.createElement('label');
  select_secondaryPackaging   = document.createElement('select');
  option0                     = document.createElement('option');
  option1                     = document.createElement('option');
  option2                     = document.createElement('option');
  option3                     = document.createElement('option');

  constructor(
    item     : OrderListItem,
    parent   : HTMLElement,
  ) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    
    // ---- Structure ----
    parent.append(this.fieldset_secondaryPackaging);
      this.fieldset_secondaryPackaging.append(this.label_secondaryPackaging);
      this.fieldset_secondaryPackaging.append(this.select_secondaryPackaging);
        this.select_secondaryPackaging.append(this.option0);
        this.select_secondaryPackaging.append(this.option1);
        this.select_secondaryPackaging.append(this.option2);
        this.select_secondaryPackaging.append(this.option3);

    // ---- Text ----
    this.label_secondaryPackaging.textContent = __('Sekundärverpackung'       , 'custom');
    this.option0.textContent                  = '— ' + __('bitte wählen'      , 'custom') +' —';
    this.option1.textContent                  = __('Grauwiler Kiste gross'    , 'custom');
    this.option2.textContent                  = __('Grauwiler Kiste klein'    , 'custom');
    this.option3.textContent                  = __('In Metzgerpapier gefaltet', 'custom');

    // ---- Other ----
    this.css('fieldset_secondaryPackaging');
    this.option0.value = 'default';
    this.option1.value = 'Kiste gross';
    this.option2.value = 'Kiste klein';
    this.option3.value = 'Metzgerpapier';
  
 
    cUtil.labelIds(this.label_secondaryPackaging, this.select_secondaryPackaging);

    // ---- Init ----
    this.option0.selected  = item.secondary_packaging === 'default';
    this.option1.selected  = item.secondary_packaging === 'Kiste gross';
    this.option2.selected  = item.secondary_packaging === 'Kiste klein';
    this.option3.selected  = item.secondary_packaging === 'Metzgerpapier';
  }

  getData() {
    return this.select_secondaryPackaging.value;
  }

  css<K extends keyof cProductItemSecondaryPackaging>(propertyName: K): void {
    const property = this[propertyName];
    if (! (property instanceof HTMLElement)) return;
    property.classList.add(propertyName);
    property.style.gridArea = propertyName;
  }
}
